import React, { useState, useEffect } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import { Spinner, Form } from 'react-bootstrap';
import Button from '../buttons/button';
import { showToast } from '../../../helpers/Utils';
import {
  useGetUnassignedOddSurveysQuery,
  useAssignSurveyToOddoLeadMutation,
} from '../../../app/surveyApi/surveyApi';

import './modalContent.css';

const AssignOdoSurveyModal = ({ show, setShow, userId }) => {
  console.log(userId,"userId");
  
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [assigningSurveyId, setAssigningSurveyId] = useState(null);

  const [assignSurveyToOddoLead] = useAssignSurveyToOddoLeadMutation();

  // Debounce the search input
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  const { data: surveyList, isLoading: isSurveyLoading } = useGetUnassignedOddSurveysQuery(
    {
      leadId: userId,
      page: 1,
      limit: 10,
      search: debouncedSearch,
    },
    {
      skip: !userId,
    }
  );

  const handleAssign = async (surveyId) => {
    setAssigningSurveyId(surveyId);
    try {
      await assignSurveyToOddoLead({ leadId: userId, surveyId }).unwrap();
      showToast('Survey assigned successfully', 'success');
    } catch (error) {
      console.error(error);
      showToast(error?.data?.message || 'Failed to assign survey', 'error');
    } finally {
      setAssigningSurveyId(null);
    }
  };

  return (
    <CommonModal show={show} setShow={setShow} title="Assign Survey">
      <Form.Control
        type="search"
        placeholder="Search surveys..."
        className="mb-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {isSurveyLoading ? (
        <div className="text-center py-3">
          <Spinner animation="border" size="sm" /> Loading...
        </div>
      ) : surveyList?.data?.unassignedSurveys?.length > 0 ? (
        <ul className="p-0 d-flex flex-xl-column gap-3">
          {surveyList.data.unassignedSurveys.map((survey) => (
            <li
              key={survey._id}
              className="d-flex justify-content-between survey-assign align-items-center"
            >
              <span className="flex-grow-1">{survey?.title}</span>
              <Button
                label={assigningSurveyId === survey._id ? 'Assigning...' : 'Assign Survey'}
                size="xs"
                disabled={assigningSurveyId === survey._id}
                onClick={() => handleAssign(survey._id)}
              />
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-center text-muted py-3">No surveys found.</div>
      )}
    </CommonModal>
  );
};

export default AssignOdoSurveyModal;
